const ChairishContext = window.chairisher.context;

/**
 * @returns {Object} The account address
 */
export function getAccountAddress() {
    return ChairishContext.ACCOUNT_ADDRESS;
}

/**
 * @returns {string} The URL from which to retrieve the Avalara eCommerce client token
 */
export function getEcommerceTokenUrl() {
    return ChairishContext.ECOMMERCE_TOKEN_URL;
}

/**
 * @returns {string} The initial ship zone to launch the Avalara eCommerce client
 */
export function getInitialShipZone() {
    return ChairishContext.INITIAL_SHIP_ZONE;
}

/**
 * @returns {Array} A list of state names that are tax free
 */
export function getTaxFreeStateNames() {
    return ChairishContext.TAX_FREE_STATE_NAMES || [];
}

/**
 * @returns {string} The text to display when a state does not collect sales tax
 */
export function getTaxFreeText() {
    return ChairishContext.TAX_FREE_TEXT;
}
